import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative font-bold" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "italic font-normal text-gray-400" }

import { useVModels } from '@vueuse/core';
import { computed } from 'vue';
import SearchDropdown from '@/components/Inputs/SearchDropdown.vue';
import { useWrestlerStore } from '@/store/wrestlers';
import { MatchParticipant } from '@/typings/scorecard';

interface Emits {
  (e: 'remove', index: number): void;
  (e: 'picked'): void;
}

interface Props {
  participant: MatchParticipant;
  index: number;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    participant: null,
    index: null
  },
  emits: ["remove", "picked"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'remove', index: number): void;
  (e: 'picked'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  participant: MatchParticipant;
  index: number;
}





const { participant: value, index } = useVModels(props);

const wrestlerStore = useWrestlerStore();
const wrestlerOptions = computed(() =>
  wrestlerStore.wrestlers.map((w) => ({
    value: w.SuperstarId,
    text: w.Name,
  }))
);
const teamOptions = computed(() =>
  wrestlerStore.teams.map((t) => ({
    value: t.TeamId,
    text: t.Name,
  }))
);

function remove() {
  emit('remove', index.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(value).SuperstarId !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SearchDropdown, {
            modelValue: _unref(value).SuperstarId,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_unref(value).SuperstarId) = $event)),
              _cache[1] || (_cache[1] = ($event: any) => (emit('picked')))
            ],
            items: _unref(wrestlerOptions)
          }, null, 8, ["modelValue", "items"])
        ]))
      : _createCommentVNode("", true),
    (_unref(value).TeamId !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(SearchDropdown, {
            modelValue: _unref(value).TeamId,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_unref(value).TeamId) = $event)),
              _cache[3] || (_cache[3] = ($event: any) => (emit('picked')))
            ],
            items: _unref(teamOptions)
          }, null, 8, ["modelValue", "items"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        class: "italic font-normal text-gray-400",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(value).ExtraText) = $event)),
        placeholder: "No text added"
      }, null, 512), [
        [_vModelText, _unref(value).ExtraText]
      ])
    ]),
    _createElementVNode("div", {
      onClick: remove,
      class: "absolute cursor-pointer -right-2 -top-2"
    }, "-")
  ]))
}
}

})